import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

export const Wrapper = styled.div`
  display: flex;
  width: 100%;
  height: 15px;
  align-items: center;
  gap: ${theme.spacing.xs};
`

export const ProgressBar = styled.div`
  width: 100%;
  height: ${theme.spacing.xs};
  border-radius: ${theme.shapes.borderRadius.sm};
  background-color: ${theme.colors.neutral.lighthover};
  overflow: hidden;
`

type ProgressFillProps = {
  color: string
  progress: number
}

export const ProgressFill = styled.div<ProgressFillProps>`
  width: ${({ progress }) => `${progress}%`};
  height: ${theme.spacing.xs};
  border-radius: ${theme.shapes.borderRadius.sm};
  background-color: ${({ color }) => color};
`

type TextProps = {
  progress: number
}

export const GraphText = styled.p<TextProps>`
  margin: 0;
  padding: 0;
  white-space: nowrap;
  line-height: ${theme.spacing.md};
  font-size: ${theme.typography.sizes['3xs']};
  font-weight: ${theme.typography.weight.sm};
  color: ${({ progress }) =>
    progress < 100 ? theme.colors.neutral.medium : theme.colors.alert.success.dark};
`
